export default __webpack_public_path__ + "static/media/im_coming.e8cc54cd.wav";